/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  GridColumn as Column,
  getSelectedState
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  cn,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@repo/ui";
import { formatDate } from "date-fns";
import { UserContext } from "utils/reducers/user";
import {
  isOperationAllowed,
  onSealFileUploadPayload,
  readOnlyExcelDate,
  showToast
} from "utils/helper";
import {
  useGetCustomerCITList,
  useGetCustomers,
  useGetShiftRoutes,
  useValidateBulkOrders
} from "utils/apis/lookups.api";
import Layout from "components/layout";
import {
  useAssignBagSeals,
  useAssignExchangeRoute,
  useCancelExchangeOrder,
  useCreateBulkExchangeOrders,
  useGetExchangeOrders,
  useValidateBulkBagsAssignment
} from "utils/apis/exchange-service.api";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";
import {
  CirclePlus,
  CircleX,
  LucideFileDigit,
  SlidersHorizontal
} from "lucide-react";
import { Loader } from "@progress/kendo-react-indicators";
import DownloadTemplate from "./download-template";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { LookUpContext } from "utils/reducers/lookup";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc"
    }
  ],
  take: 25,
  skip: 0
};

const currentDate = new Date();

export default function Exchange() {
  const user = useContext(UserContext);
  const { allBagTypes, coinContainers, currencies } = useContext(LookUpContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [filters, setFilters] = useState<any>(
    user.filters?.["exchange-services"] || {}
  );
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [btnAssignRouteDis, setBtnAssignRouteDis] = useState(true);
  const [btnAssignRouteTxt, setBtnAssignRouteTxt] = useState("Assign Route");
  const [btnCancelDis, setBtnCancelDis] = useState(true);
  const [btnCancelTxt, setBtnCancelTxt] = useState("Cancel");
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 25;

  const [openSealFileUpload, setOpenSealFileUpload] = useState(false);
  const [sealAssignType, setSealAssignType] = useState("");
  const [bagSealData, setBagSealData] = useState<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [routesTeams, setRoutesTeams] = useState<any[]>([]);
  const [fileReady, setFileReady] = useState(false);

  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;

  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user?.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    )
  });

  const {
    mutate: validateExchangeBulkOrders,
    isPending: validateOrdersPending,
    isSuccess: validateOrdersSuccess,
    isError: validateOrdersError,
    data: validateData,
    reset: validateReset
  } = useValidateBulkOrders();

  const {
    mutate: createBulkOrders,
    isPending: bulkExchangePending,
    isSuccess: bulkExchangeSuccess,
    isError: bulkExchangeError,
    data: bulkCreationResponseData
  } = useCreateBulkExchangeOrders();

  const {
    mutate: cancelExchangeOrder,
    isSuccess: cancelSuccess,
    isError: cancelError
  } = useCancelExchangeOrder();

  const {
    mutate: validateBulkBagsAssignment,
    isPending: validateBulkBagsAssignmentPending,
    isSuccess: validateBulkBagsAssignmentSuccess,
    isError: validateBulkBagsAssignmentError,
    reset: validateBagReset
  } = useValidateBulkBagsAssignment();

  const {
    mutate: assignBagSeals,
    isPending: assignBagSealsPending,
    isSuccess: assignBagSealsSuccess,
    isError: assignBagSealsError,
    data: assignBagData
  } = useAssignBagSeals();
  const {
    mutate: assignExchangeRoute,
    isSuccess: successExchangeRoute,
    isError: errorExchangeRoute
  } = useAssignExchangeRoute();

  const { data: customers } = useGetCustomers();
  const { data: sourceLocationsData } = useGetCustomerCITList(
    filters?.customer?.id
  );

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests
  } = useGetExchangeOrders({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id?.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceSPId?.id || ""
  });

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key]
    }));

    const selectedRequests: any = selections.filter(
      (req) => req.isSelected === true
    );

    const requestIds = selectedRequests.map((req: any) => ({
      itemKey: req.itemKey
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {/* {isOperationAllowed(Permissions.Exchange, Permissions.View) ? ( */}
        <Link
          to="/exchange-services-detail"
          state={{
            requestId,
            jobNo
          }}
        >
          {orderId}
        </Link>
        {/* // ) : (
        //   orderId
        // )} */}
      </td>
    );
  }

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const routeNo = ddlInRouteTeams;

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1]
    }));

    const selectedRoute: any = inRouteTeams?.find(
      (item: any) => item?.routeNo === ddlInRouteTeams
    );

    const assignmentDto: any = {
      cashCenterId: filters?.cashCenter || user?.CashCenterId,
      operationDate: formatDate(
        filters?.operationDate?.id || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      routeNo,
      requests: requestsIds,
      shift: "morning",
      fieldTeam: selectedRoute?.fieldTeam
    };

    setBtnAssignRouteDis(true);
    setBtnAssignRouteTxt("Assigning...");
    assignExchangeRoute(assignmentDto);
  };

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "Selected job to cancel.");
      return;
    }

    setBtnCancelDis(true);
    setBtnCancelTxt("Canceling...");
    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1]
    }));

    cancelExchangeOrder(requestsIds);
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceLocation, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val)
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "exchange-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val)
      }
    });
  };

  const onAssignSealModal = (type: string) => {
    setOpenSealFileUpload(true);
    setSealAssignType(type);
  };

  const handleBillingCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleSourceLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceLocation", val);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value }
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "exchange-services": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value }
        }
      });
    }
    setCurrentPage(1);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: {
        name: e.target.value,
        id: e.target.value
      }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "exchange-services": {
        ...filters,
        searchCriteria: {
          name: e.target.value,
          id: e.target.value
        }
      }
    });
  };

  const onDdlInRouteTeamsChanged = (value: string) => {
    if (!value) {
      setDdlInRouteTeams("");
      return;
    }
    setDdlInRouteTeams(value);
    if (selectedRequests.length > 0) setBtnAssignRouteDis(false);
    else setBtnAssignRouteDis(true);
  };

  const onSealFileUpload = async (event: any) => {
    const payload = await onSealFileUploadPayload(
      event,
      sealAssignType,
      allBagTypes,
      coinContainers,
      currencies
    );
    setBagSealData(payload);
    validateBulkBagsAssignment(payload);
  };
  const onConfirmBagSeals = () => {
    assignBagSeals(bagSealData);
  };

  const onConfirmFileOrders = () => {
    if (routesTeams.length === 0) {
      showToast("error", "No orders to add. Please upload a file first.");
      return;
    }
    createBulkOrders(routesTeams);
  };

  const resetUploadState = (closeDialog = true) => {
    setRoutesTeams([]);
    setFileReady(false);
    validateReset();
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (closeDialog) setOpenFileUpload(false);
  };

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "exchange-services": updatedFilter
    });
  };

  const fileHandler = (event: any) => {
    const fileObj = event?.target?.files?.[0] as File | null;
    if (!fileObj) return;

    const supportedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "csv",
      "text/csv"
    ];

    // Some browsers may not populate fileObj.type for CSV; allow by extension fallback
    const filename = (fileObj.name || "").toLowerCase();
    const extOk =
      filename.endsWith(".csv") ||
      filename.endsWith(".xls") ||
      filename.endsWith(".xlsx");

    if (!supportedTypes.includes(fileObj.type) && !extOk) {
      showToast("error", "File format not supported.");
      return;
    }

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", String(err));
        setFileReady(false);
        return;
      }
      const rows = resp?.rows || [];
      const parsed: any[] = [];

      if (!rows.length) {
        showToast("error", "Excel file is empty.");
        setFileReady(false);
        return;
      }

      // parse each data row starting from 2nd row (index 1)
      for (let idx = 1; idx < rows.length; idx += 1) {
        const row = rows[idx] || [];

        // skip entirely empty rows
        const allEmpty = row.every(
          (c: any) => c === null || c === undefined || String(c).trim() === ""
        );
        if (allEmpty) continue;

        const sourceBarcode = row[0];
        const onwardBarcode = row[1];
        const serviceDate = row[2];
        const invoicingModel = row[3];
        const jobNature = row[4];
        const jobType = row[5];
        const priority = row[6];
        const routeNo = row[7];
        const requestedBy = row[8];
        // skip if both barcodes  is missing
        if (!sourceBarcode && !onwardBarcode) continue;

        parsed.push({
          sourceBarcode: String(sourceBarcode || "").trim(),
          onwardBarcode: String(onwardBarcode || "").trim(),
          serviceDate: readOnlyExcelDate(serviceDate),
          invoicingModel,
          priority,
          jobType,
          jobNature,
          routeNo,
          shift: "morning",
          requestedBy
        });
      }

      if (parsed.length > 0) {
        setRoutesTeams([...parsed]);
        setFileReady(true);
        validateExchangeBulkOrders([...parsed]);
      } else {
        showToast("error", "No valid data found in Excel file.");
        setFileReady(false);
      }
    }); // end ExcelRenderer
  }; // end fileHandler

  useEffect(() => {
    if (validateOrdersError || validateData) {
      resetUploadState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError, validateData]);

  useEffect(() => {
    if (bulkExchangeSuccess) {
      resetUploadState(true);
      showToast("success", "Bulk exchange orders uploaded successfully.");
    }

    if (bulkExchangeError) {
      resetUploadState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkExchangeSuccess, bulkExchangeError]);

  useEffect(() => {
    if (cancelSuccess) {
      setBtnCancelDis(true);
      setBtnCancelTxt("Cancel");
      setSelectedState({});
    }
    if (cancelError) {
      setBtnCancelDis(false);
      setBtnCancelTxt("Cancel");
    }
  }, [cancelError, cancelSuccess]);

  useEffect(() => {
    if (successExchangeRoute) {
      setDdlInRouteTeams("");
      setSelectedState({});
      setBtnAssignRouteTxt("Assign Route");
    }

    if (errorExchangeRoute) {
      setBtnAssignRouteDis(false);
      setBtnAssignRouteTxt("Assign Route");
    }
  }, [successExchangeRoute, errorExchangeRoute]);

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  useEffect(() => {
    if (validateBulkBagsAssignmentError) {
      setOpenSealFileUpload(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
      validateBagReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateBulkBagsAssignmentError]);

  useEffect(() => {
    if (assignBagSealsSuccess) {
      setOpenSealFileUpload(false);
      setBagSealData([]);
    }

    if (assignBagSealsError) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
    }
  }, [assignBagSealsSuccess, assignBagSealsError]);

  useEffect(() => {
    if (assignBagData?.consignments?.length) {
      excelExport1?.save(assignBagData?.consignments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagData]);

  useEffect(() => {
    if (bulkCreationResponseData?.length) {
      excelExport2?.save(bulkCreationResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkCreationResponseData]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Exchange </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId
                        }),
                        label: item.name
                      }))}
                      setValue={handleBillingCustomer}
                    />

                    <Combobox
                      placeholder="Select Source Location"
                      value={JSON.stringify(filters?.sourceLocation) || ""}
                      data={sourceLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item.servicePointId
                        }),
                        label: `${item.barcode}-${item.locationId}`
                      }))}
                      setValue={handleSourceLocation}
                    />

                    {/* <Combobox
                      placeholder="Select Destination Location"
                      value={JSON.stringify(filters?.onwardLocation) || ""}
                      data={onwardLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: item.locationName,
                          id: item.servicePointId,
                        }),
                       label: `${item.barcode}-${item.locationId}`,
                      }))}
                      setValue={handleDestinationLocation}
                    /> */}
                  </div>
                </PopoverContent>
              </Popover>

              <div className="w-[15%]">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || new Date()}
                  onSelectDate={onOperationDateChanged}
                />
              </div>

              {isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
                <div className="w-[15%]">
                  <Combobox
                    setValue={onDdlInRouteTeamsChanged}
                    value={ddlInRouteTeams}
                    placeholder="Select Route"
                    data={inRouteTeams?.map((item: any) => ({
                      value: item?.routeNo,
                      label: `${item.routeNo} (${item.description})`
                    }))}
                  />
                </div>
              ) : null}

              <div className="w-[10%]">
                {loadingRequests ? (
                  <div className="text-end">
                    <Loader size="large" type="pulsing" />
                  </div>
                ) : null}
              </div>

              <div className="flex-1 flex justify-end gap-2">
                {isOperationAllowed(Permissions.B2B, Permissions.Add) ? (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <CirclePlus /> Create Request
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-[180px]">
                      <DropdownMenuItem>
                        <Link
                          to="/create-exchange-service"
                          state={{ createType: "single" }}
                        >
                          Single Request
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuItem
                        onClick={() => {
                          setOpenFileUpload(true);
                        }}
                        className="cursor-pointer"
                      >
                        Bulk Requests
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : null}

                {isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
                  <Button
                    variant="secondary"
                    disabled={btnAssignRouteDis}
                    onClick={onBtnAssignRouteClicked}
                  >
                    {btnAssignRouteTxt}
                  </Button>
                ) : null}
              </div>
              {isOperationAllowed(Permissions.B2B, Permissions.Edit) && (
                <DownloadTemplate operationDate={filters?.operationDate?.id} />
              )}
              {isOperationAllowed(Permissions.B2B, Permissions.Edit) && (
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="secondary" className="gap-2">
                      <LucideFileDigit /> Bulk Bags Assignment
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="start" className="w-[180px]">
                    <DropdownMenuItem
                      onClick={() => {
                        onAssignSealModal("Single Currency");
                      }}
                      className="cursor-pointer"
                    >
                      Single Currency
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={() => {
                        onAssignSealModal("AED Coins");
                      }}
                      className="cursor-pointer"
                    >
                      AED Coins
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={() => {
                        onAssignSealModal("Foreign Currency");
                      }}
                      className="cursor-pointer"
                    >
                      Foreign Currency
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              )}
              {/* {isOperationAllowed(Permissions.B2B, Permissions.Cancel) ? ( */}
              <Button
                variant="secondary"
                disabled={btnCancelDis}
                onClick={onBtnCancelClicked}
              >
                {btnCancelTxt}
              </Button>
              {/* ) : null} */}
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null
              )}
            </div>
            <div className="border-b my-3 bg-accent" />
            <div className="flex justify-end mb-3">
              {isOperationAllowed(Permissions.Kiosk, Permissions.Search) ? (
                <Input
                  className="max-w-[420px] w-full ml-auto mb-3"
                  value={filters?.searchCriteria?.id}
                  onChange={onFilterSearch}
                  title="Search: Job No., Job Nature, Status, Route No."
                  placeholder="Search: Job No., Job Nature, Status, Route No."
                />
              ) : null}
            </div>
            {loadingRequests ? (
              loadingPanel
            ) : (
              <Grid
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                selectable={{
                  enabled: true,
                  drag: true,
                  cell: false,
                  mode: "multiple"
                }}
                data={process(
                  requestsData?.data?.map((req: any) => ({
                    ...req,
                    [SELECTED_FIELD]: selectedState[idGetter(req)]
                  })) || [],
                  { ...dataState, skip: 0 }
                )}
                {...dataState}
                onDataStateChange={(e) => {
                  setDataState(e.dataState);
                }}
                sortable
                filterable
                pageable
                total={totalRecords}
                pageSize={pageSize}
                skip={(currentPage - 1) * pageSize}
                onPageChange={onPageChange}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                size="small"
              >
                <Column
                  field={SELECTED_FIELD}
                  filterable={false}
                  width="40px"
                  headerSelectionValue={
                    requestsData?.data
                      ?.map((req: any) => ({
                        ...req,
                        itemKey: `${req.requestId}_${req.jobNo}`,
                        selected: false
                      }))
                      ?.findIndex(
                        (item: any) => !selectedState[idGetter(item)]
                      ) === -1
                  }
                  className="text-center"
                />
                <Column
                  cell={ShowDetailsButtonCell}
                  field="orderId"
                  title="Order Id"
                  width={160}
                />
                <Column field="jobNo" title="Job #" width={90} />
                <Column field="customer" title="Customer" width={190} />
                <Column field="barcode" title="Barcode" width={160} />
                <Column field="locationId" title="Location Id" width={160} />
                <Column field="locationName" title="Name" width={160} />
                <Column
                  field="routeNo"
                  title="Route"
                  width={140}
                  className="text-center"
                />

                <Column field="jobNature" title="Job Nature" width={110} />

                <Column
                  field="status"
                  title="Status"
                  className="text-center"
                  width={140}
                />

                <Column field="requestedBy" title="Requested By" width={140} />
                <Column
                  field="remarks"
                  title="Remarks"
                  headerClassName={cn("max-w-md w-48")}
                  className={cn("max-w-md w-48")}
                />
              </Grid>
            )}
          </CardDescription>
        </CardContent>
      </Card>
      <ExcelExport
        ref={(exporter) => {
          excelExport1 = exporter;
        }}
        fileName={`Exchange_Bags_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "containerType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "declaredValue", title: "Value" },
          { field: "denominations", title: "Coins Denomination" },
          { field: "denomination", title: "Note Denomination" },
          { field: "count", title: "Count" },
          { field: "assigmentStatus", title: "Status" },
          { field: "locationId", title: "Location ID" }
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport2 = exporter;
        }}
        fileName={`Exchange_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "serviceDate", title: "Service Date" },
          { field: "invoicingModel", title: "Invoicing Model" },
          { field: "jobType", title: "Job Type" },
          { field: "jobNature", title: "Job Nature" },
          { field: "routeNo", title: "Route No" },
          { field: "requestedBy", title: "Requested By" },
          { field: "status", title: "Status" },
          { field: "message", title: "Message" }
        ]}
      />
      {/* Bulk Orders Upload Dialog */}
      <Dialog open={openFileUpload} onOpenChange={setOpenFileUpload}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Exchange Orders</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {fileReady ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{routesTeams.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmFileOrders}
                    isLoading={validateOrdersPending || bulkExchangePending}
                    disabled={!validateOrdersSuccess || bulkExchangePending}
                  >
                    Add orders
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      // allow re-upload / choose another file
                      resetUploadState(false);
                      setOpenFileUpload(true);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      {/* Assign Seal Orders */}

      <Dialog
        open={openSealFileUpload}
        onOpenChange={() => {
          setBagSealData([]);
          setOpenSealFileUpload(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{sealAssignType} Per Bag</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {bagSealData.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{bagSealData.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmBagSeals}
                    isLoading={
                      validateBulkBagsAssignmentPending || assignBagSealsPending
                    }
                    disabled={
                      !validateBulkBagsAssignmentSuccess ||
                      assignBagSealsPending
                    }
                  >
                    Assign Seals
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      if (fileInputRef.current) fileInputRef.current.value = "";
                      setBagSealData([]);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onChange={onSealFileUpload}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image" />
    <div className="k-loading-color" />
  </div>
);
